var $ = require('@alife/alpha-jquery/jquery');
var _ = require('@alife/alpha-underscore/underscore');

/**
 * @param path
 * a.b.c[] -> [a, b, c]
 * a.b.c[1] -> [a, b, c, 1]
 */
function parsePath(path) {
    path = path.replace(/\[(.*?)\]/g, function (match, index) {
        if (index != '') {
            return '.' + index;
        } else {
            return '';
        }
    });
    var parts = path.split('.');
    return parts;
}

function get(json, path) {
    var parts = parsePath(path);
    var value = _.reduce(parts, function (json, key) {
        if (json != undefined) {
            return json[key];
        }
    }, json);
    return value;
}

function set(json, path, value) {
    var parts = parsePath(path);
    // step1: find parent
    var parent = _.reduce(parts, function (json, key, index) {
        if (json[key] === undefined) {
            // 后一个key为数字则创建数组
            if (!isNaN(parts[index + 1])) {
                json[key] = [];
            } else {
                json[key] = {};
            }
        }
        // 最后一个part时， 直接返回json
        if (index == parts.length - 1) {
            return json;
        } else {
            return json[key];
        }
    }, json);
    // step2: set value
    var lastKey = parts.pop();
    parent[lastKey] = value;
    return json;
}

module.exports = {
    pathValue: function (json, path, value) {
        if (arguments.length > 2) {
            return set(json, path, value);
        } else {
            return get(json, path);
        }
    },
    /**
     * 将值对转换为json对象
     */
    param2json: function (params) {
        var json = {};

        if (~params.indexOf('=')) {
            var parts = params.split('&');

            $.each(parts, function (index, part) {
                var pair = part.split('='),
                    key = decodeURIComponent(pair[0]),
                    value = decodeURIComponent(pair[1]);

                //判断为checkbox
                if (json[key]) {
                    if (!$.isArray(json[key])) {
                        var tmp = json[key];
                        json[key] = [];
                        json[key].push(tmp);
                    }
                    json[key].push(value);
                } else {
                    json[key] = value;
                }
            });
        }
        return json;
    }
};
